import React, {useState, Component, useEffect, lazy } from 'react'; 
import Banner1 from '@/layout/banner';
import { BANNERPAGE } from '@/config/banner_config';
import { FORMSDATA } from '@/config/forms_config';
import dynamic from "next/dynamic";
import "aos/dist/aos.css";
import AOS from 'aos';
import { SEODATA } from '@/config/seo_config';
import { FAQS } from "@/config/faq_config";
import Head from 'next/head';
import IMAGES from '@/public/assets/img';
import TestimonialSlider from '@/component/shared/testimonialSlider';
import { generateFaqSchema } from "@/component/shared/faqSchema";



const AccordianFaq = dynamic(() => import('@/component/shared/accordianfaq'));
const SolutionBriefPopup = dynamic(() => import('@/component/shared/solutionBrief'));
const BrandCarousel = dynamic(() => import('@/component/shared/brandCarousel'));
const Finance1 = dynamic(() => import('@/component/shared/exploreSolution'));
const CraftedFinance = dynamic(() => import('@/component/shared/craftedfinance'));
const FormsPopups = lazy(() => import('@/component/shared/formsPopups'));

const Customers={
    heading:'Our Happy Clients',
    paragraph: 'What they say about us',
    knowMoreCta: 'Know more',
    customersList:[
        {CustomerQuote:"We significantly improved our suppliers' cash cycle, allowing efficient invoice-to-cash processing", CustomerName:'Aditya Birla', CustomerDesignation:'Aditya Birla || Fashion & Retail', cta:'CredlixCasestudyAditya', src:IMAGES.HomeNew.adityaImg, },
        {CustomerQuote:'Their understanding and knowledge of financing solutions have been valuable for our business.',CustomerName:'Deepak Gaur Sharma', CustomerDesignation:'MD || Accord', cta:'CredlixCasestudyAccord', src:IMAGES.HomeNew.accordImg},
        {CustomerQuote:'Manufacturing company automates supply chain financing',CustomerName:'Ishita Bowry',CustomerDesignation:'Director - Finance ||TwigaFiber', cta:'CredlixCasestudyTwigafiber', src:IMAGES.HomeNew.twigaImg},
        {CustomerQuote:'The entire process of working with the Credlix team has been easy and end-to-end digital.',CustomerName:'Ujwal Desai',CustomerDesignation:'CEO & Founder || Lucro', cta:'CredlixCasestudyUjwal', src:IMAGES.HomeNew.lucroImg},
        {CustomerQuote:'Food processing company adds significant value to its supply chain',CustomerName:'Vinod Jobanputra',CustomerDesignation:'CEO & Founder || Lalsai Dehy Foods', cta:'CredlixCasestudyVinod', src:IMAGES.HomeNew.vinodImg},
    
      ]
  }

export const metadata = {
    title: SEODATA.DOMESTIC.title,
    description: SEODATA.DOMESTIC.description,
    keywords: SEODATA.DOMESTIC.keyword,
    alternates: {
      canonical: SEODATA.DOMESTIC.url
    },
    
    openGraph: {
      title: SEODATA.DOMESTIC.title,
      description: SEODATA.DOMESTIC.description,
      url: SEODATA.DOMESTIC.url,
    }
  };

const Domestic = () =>{    
    const [show, setShow] = useState(false);
    const [showSolution, setShowSolution] = useState(false);
    const formSBType = 'DownloadSolutionExporters';
    const formType="RequestDemo";
    // For FAQs
    const [open, setOpen]= useState(false);
    const faqSchema = generateFaqSchema(FAQS.DOMESTIC);
    
    const toggle = (index) => {
    if(open === index){
        return setOpen(null)
    }
    setOpen(index)
    }

    const showModal = () => {
        setShow(true);
    }
    const showSolutionModal = () => {
        setShowSolution(true);
    }
    const handleOnClose =()=>{
        setShow(false);
    } 
    const handleOnCloseSolution =()=>{
        setShowSolution(false);
    }  
    useEffect(() => {
        AOS.init();
      }, []); 
    return(
        <main>
            <Head>  
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                {/* OpenGraph tags */} 
                <meta property="og:title" content={metadata.openGraph.title} />
                <meta property="og:description" content={metadata.openGraph.description} />
                <meta property="og:url" content={metadata.openGraph.url} />
                <link rel="canonical" href={metadata.alternates.canonical} />
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                    __html: JSON.stringify(faqSchema)
                    }}
              />
            </Head>
            <Banner1 classes='w-full flex relative justify-end sm:flex-wrap' 
                            title={BANNERPAGE.domestic.banner[0].title} subtitle={BANNERPAGE.domestic.banner[0].subtitle} paratitle={BANNERPAGE.domestic.banner[0].paratitle} bannerimg={BANNERPAGE.domestic.banner[0].bannerimg} 
                            download={showSolutionModal} cta={BANNERPAGE.domestic.banner[0].cta} imageclasses="relative bg-right-top w-[550px] md:w-full sm:w-full m-auto" />
                                    
            <section className='crafted_finance bg-white py-20'>
                <div className='container  lg:px-3 px-3 sx:px-2'>
                    <div className='heading-section' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                        <h2 className='text-xxl text-secondary font-bold text-center'>Carefully Crafted To Manage Your Finances</h2>
                        <p className='text-base2 text-secondary text-center mt-1 mb-6'>Whether you are expanding your business or looking for working capital, plug into our solutions for enabling seamless cash flow into your business. We are an agile disruptor empowering enterprise to innovate and streamline your supply chain operations.</p>
                    </div>
                    <div>
                    <CraftedFinance iconimg={BANNERPAGE.craftedcommon.datacrafted[0].iconimg} iconimg1={BANNERPAGE.craftedcommon.datacrafted[0].iconimg1} iconimg2={BANNERPAGE.craftedcommon.datacrafted[0].iconimg2}
                    iconimg3={BANNERPAGE.craftedcommon.datacrafted[0].iconimg3} iconheading={BANNERPAGE.craftedcommon.datacrafted[0].iconheading} iconheading1={BANNERPAGE.craftedcommon.datacrafted[0].iconheading1}
                    iconheading2={BANNERPAGE.craftedcommon.datacrafted[0].iconheading2} iconheading3={BANNERPAGE.craftedcommon.datacrafted[0].iconheading3} iconsubheading={BANNERPAGE.craftedcommon.datacrafted[0].iconsubheading}
                    iconsubheading1={BANNERPAGE.craftedcommon.datacrafted[0].iconsubheading1} iconsubheading2={BANNERPAGE.craftedcommon.datacrafted[0].iconsubheading2} iconsubheading3={BANNERPAGE.craftedcommon.datacrafted[0].iconsubheading3}
                    cta={BANNERPAGE.craftedcommon.datacrafted[0].cta} requestdemo={showModal}
                    />
                    </div>
                </div>
            </section>
            <Finance1 classes='w-full' 
                            heading={BANNERPAGE.domestic1.data[0].heading}
                            title={BANNERPAGE.domestic1.data[0].title} subtitle={BANNERPAGE.domestic1.data[0].subtitle} learncta={BANNERPAGE.domestic1.data[0].learncta} url={BANNERPAGE.domestic1.data[0].url} exploreimg={BANNERPAGE.domestic1.data[0].exploreimg} 
                            imageclasses="relative right-0" />
           
            {/* Testimonial Section Starts */}
            {Customers &&
            <section className="py-20 sm:py-[30px]">
                <div className="container px-3 lg:px-3 xm:px-2">
                <h2 className="mb-3 font-semibold text-center text-black text-xxxl sm:text-xl">{Customers.heading}</h2>
                <p className="text-center text-base2 text-secondary font-regular">{Customers.paragraph}</p>
                <TestimonialSlider content={Customers.customersList} interval={3000} />
                </div>
            </section>
            }
          {/* Testimonial Section Ends */}
            <div className='bg-[#F4F7FD]'>
            <BrandCarousel/>
            </div>
            {FAQS.DOMESTIC &&
            <section className='bg-white py-20 grid place-items-center' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                            <div className='container  lg:px-3 px-3 xm:px-2'>
                            <div>
                            <h3 className='text-xxxl text-secondary text-center font-bold mb-6'>Frequently Asked Questions</h3>
                            </div>
                            <div className="bg-white w-full text-left m-auto" data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                <div className="mx-auto  sm:w-auto">
                                <AccordianFaq faqData={FAQS.DOMESTIC} />
                                </div>      
                            </div>
                            </div>
             </section>}
            
          
            <FormsPopups formType={formType} onClose={handleOnClose} heading={FORMSDATA.SIGNUP_FOR_DEMO.requestdemo.heading} subheading={FORMSDATA.SIGNUP_FOR_DEMO.requestdemo.subheading} formimage={FORMSDATA.SIGNUP_FOR_DEMO.requestdemo.image} show={show} setShow={(bool) => setShow(bool)} />
            <SolutionBriefPopup formType={formSBType} onClose={handleOnCloseSolution} heading={FORMSDATA.SOLUTION_BRIEF.downloadsolution.heading} subheading={FORMSDATA.SOLUTION_BRIEF.downloadsolution.subheading} formimage={FORMSDATA.SOLUTION_BRIEF.downloadsolution.image} show={showSolution} setShowSolution={(bool) => setShow(bool)} />
        </main>
        
    );
    };
    
    export default Domestic;